let sttypes = ["Monthly", "Weekly", "Daily"];
export default sttypes;
